export const EQUIPMENT_KINDS = ['CARDIO', 'STRENGTH', 'FREE_WEIGHTS', 'OTHER'] as const;
export type EquipmentKind = (typeof EQUIPMENT_KINDS)[number];

export const EQUIPMENT_STATUSES = ['IN_SERVICE', 'OUT_OF_ORDER', 'RETIRED'] as const;
export type EquipmentStatus = (typeof EQUIPMENT_STATUSES)[number];

export const TICKET_PRIORITIES = ['LOW', 'NORMAL', 'URGENT'] as const;
export type TicketPriority = (typeof TICKET_PRIORITIES)[number];

export const TICKET_STATUSES = ['OPEN', 'IN_PROGRESS', 'RESOLVED', 'WONT_FIX'] as const;
export type TicketStatus = (typeof TICKET_STATUSES)[number];

/** Tickets still being dealt with: they keep a machine from going back into service and are never opened twice for planned service. */
export const TICKET_OPEN_STATUSES = ['OPEN', 'IN_PROGRESS'] as const satisfies readonly TicketStatus[];
export type TicketOpenStatus = (typeof TICKET_OPEN_STATUSES)[number];

export function isOpenTicketStatus(status: string): status is TicketOpenStatus {
  return (TICKET_OPEN_STATUSES as readonly string[]).includes(status);
}

/** What a ticket's timeline records. Every kind that moves the ticket carries the status it moved to. */
export const TICKET_EVENT_KINDS = ['CREATED', 'STATUS_CHANGED', 'ASSIGNED', 'UPDATED', 'NOTE', 'EQUIPMENT_STATUS'] as const;
export type TicketEventKind = (typeof TICKET_EVENT_KINDS)[number];
